<template>
  <div class="count-chart"></div>
</template>

<script>
  export default {
    props: {
      countChartData: {
        type: Array,
        required: true,
      },
      countChartColors: {
        type: Array,
        required: true,
      },
    },
    data() {
      return {
        target: undefined,
      };
    },
    mounted() {
      this.buildChart();
      this.target.setSize(null);
    },

    methods: {
      buildChart() {
        this.target = Highcharts.setOptions({
          colors: this.countChartColors,
        });

        this.target = Highcharts.chart(this.$el, {
          chart: {
            plotBackgroundColor: null,
            plotBorderWidth: null,
            plotShadow: false,
            type: 'pie',
          },
          title: {
            text: 'Email & IM Count',
            style: {
              fontWeight: 'bold',
              fontSize: '20px',
            },
          },
          tooltip: {
            enabled: true,
            formatter() {
              this.name = this.key.slice(1);
              return this.name;
            },
          },
          plotOptions: {
            pie: {
              allowPointSelect: false,
              cursor: 'pointer',
              dataLabels: {
                enabled: true,
                formatter() {
                  this.name = this.key[0];
                  return `${this.name} : ${this.y}`;
                },
              },
            },
          },
          series: [
            {
              name: 'Email & IM Count',
              colorByPoint: true,
              data: this.countChartData,
            },
          ],
          credits: {
            enabled: false,
          },
        });
      },
    },

    beforeDestroy() {
      if (this.target) this.target.destroy();
    },
  };
</script>
<style lang="scss" scoped>
  .count-chart {
    width: 100%;
    max-width: 400px;
  }
</style>
